module.exports = __webpack_public_path__ + "static/media/test16_3.eca326a6.png";